import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ModalService } from 'src/app/services/modal.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { PersistenceService } from 'src/app/services/persistence.service';

@Component({
    selector: 'app-initial-login',
    templateUrl: './initial-login.component.html',
    styleUrl: './initial-login.component.scss',
    standalone: false
})
export class InitialLoginComponent {
  isSubmitting = false;
  isFormCompleted = false;
  loginID;
  regcode;
  errorMsg;
  paxType;
  paxTypeList = [
    {display: "Top Producing Financial Professionals", value:1},
    {display: "Advisory Board / Council Member", value:2},
    {display: "Financial Professionals", value:3},
    {display: "Support Staff", value:4},
    {display: "Strategic Partner / Speaker", value:5},
    {display: "Other", value:6},
    {display: "Vendor", value:7},
    {display: "Home Office", value:8},
   {display: "Corporate Guest", value:9},
   {display: "Event Producer", value:10}
  ];
 
  constructor(
    private authenticationService:AuthenticationService,
    private navigationService: NavigationService,
    private persistenceService: PersistenceService,
    private modalService: ModalService,
    private router: Router){
  }

  forward(form){
    console.log("forward");
    console.log(form);
    if(!this.isSubmitting && form.valid){
      this.isFormCompleted = true;
      this.isSubmitting = true;
      const creds: any = {};
        creds.username = this.loginID;
        creds.password = 'password';
        if(this.isSubmitting){
          this.authenticationService.initialLogin(creds, this.regcode, this.paxType).then(() => {
          //login ID found - login happy path
          this.navigationService.forward();
          }, (err) => {
            if(err === 'Login cannot be found.'){
              //login ID not found, if paxtype 1 or 2 selected then error them out saying login cannot be found
              if(this.paxType === 1 || this.paxType == 2){
                this.isSubmitting =false;
                this.errorMsg = err;
              }else{
                //if they did not select paxtype 1 or 2, set username to "login" and try to log them in again
                //if you are not paxtype 1 or 2 then it is an open login
                creds.username = "login";
                this.authenticationService.initialLogin(creds, this.regcode, this.paxType).then(() => {      
                this.navigationService.forward();
                },(err) => {
                  //if some sort of error returned then error out on login page
                  this.isSubmitting =false;
                  this.errorMsg = err;
                });
              }
            }else{
              //err !== 'Login cannot be found.'
              //display error message
              //this could be already registered or cancelled error message
              this.isSubmitting =false;
              this.errorMsg = err;          
            }          
          });
        }

    }
  }
  declineButtonClick() {

    this.persistenceService.testStorage();
    this.persistenceService.clear();

    const creds: any = {};
    console.log(this.loginID);
    creds.username = this.loginID;
    creds.password = 'password';

    if (this.loginID) {
      this.authenticationService.initialLogin(creds, this.regcode, this.paxType).then(() => {
        //  promise resolved
        //this.router.navigate(['/invitation']);
        this.authenticationService.updateProfile('CANCELLED', "Declined from Login Page").subscribe(() => {
          this.router.navigate(['decline']);
      });

      }, (err) => {
        this.errorMsg = err;
      });
    }

  }

  openModal(copy, title, actionButtonText) {
    this.modalService.openModal(copy, title, actionButtonText);
  }
}
